require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./author-the-great-king-bear.json") })
        }
      }, "path---author-the-great-king-bear");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---author-the-great-king-bear!./.cache/json/author-the-great-king-bear.json
// module id = 398
// module chunks = 231608221292675